<script setup lang="ts">
import { RouterView } from 'vue-router'
import TheHeader from '@/components/TheHeader.vue'
import { onMounted } from 'vue'

onMounted(() => {
  const userAgent = navigator.userAgent.toLowerCase()
  if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
    document.body.classList.add('safari-specific')
  }
})
</script>

<template>
  <main>
    <div class="wrapper">
      <TheHeader />
      <RouterView />
    </div>
  </main>
</template>

<style lang="scss">
/*deprecation warning of imports css TODO: fix*/

.wrapper {
  max-width: 1200px;
  padding: 0 16px; /* add padding to the sides */
  box-sizing: border-box; /* include padding in the width */
}

@page {
  margin-top: 0;
  margin-bottom: 0;
}

@media print {
  .safari-specific body,
  .safari-specific html,
  body.safari-specific {
    width: 215mm;
    overflow: visible;
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
